import { render, staticRenderFns } from "./mainLayout.vue?vue&type=template&id=2da73a88&"
import script from "./mainLayout.vue?vue&type=script&lang=js&"
export * from "./mainLayout.vue?vue&type=script&lang=js&"
import style0 from "./mainLayout.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports